export default __webpack_public_path__ + "assets/trash-component.a4140fca.svg";